<app-auth-modal-layout>
  <h2 class="text-lg font-medium sm:text-xl md:text-2xl text-center">
    Forgot your Password?
  </h2>

  <p class="text-center text-sm font-light">
    Enter your email address and we’ll send you a link to reset your password
  </p>

  <form
    appForgotPasswordSubmit
    autocomplete="off"
    [formGroup]="form"
    class="flex flex-col">
    <div class="flex flex-col gap-1">
      <app-ccs-input
        label="Email Address"
        placeholder="email@email.com"
        [formControlName]="formControls.EMAIL"
        [errorMessages]="ERROR_MESSAGES.email" />
    </div>

    <div class="text-sm font-light my-3">
      Remember Password?
      <button
        type="button"
        class="underline font-semibold cursor-pointer"
        (click)="openLogin($event)">
        Login
      </button>
    </div>

    <div class="flex gap-2 sm:gap-4 mt-3">
      <ui-button
        type="button"
        variant="tertiary"
        class="w-full"
        (click)="close($event)">
        Cancel
      </ui-button>
      <ui-button
        type="submit"
        variant="primary"
        class="w-full"
        [disabled]="isSubmitDisabled">
        @if (isLoading()) {
          <div class="flex flex-row justify-center items-center gap-2">
            <span appIcon name="spinner" [size]="16"></span>
            {{ submitLabel() }}
          </div>
        } @else {
          {{ submitLabel() }}
        }
      </ui-button>
    </div>
  </form>
</app-auth-modal-layout>
